import { api } from "./client";

export interface Branding {
  app_name: string;
  /** Ime ispod ikone na početnom zaslonu; prazno = skraćeni app_name. */
  short_name: string;
  logo: string | null;
  /** Ikona instalirane aplikacije (PWA) — null dok nije izvedena iz logotipa. */
  icon: string | null;
  updated_at?: string;
}

/** Public — works without authentication (login screen needs the logo). */
export async function getBranding(): Promise<Branding> {
  const { data } = await api.get<Branding>("/branding/");
  return data;
}

/** Server-admin only. Pass a FormData with `app_name`, `logo` (File) and/or
 *  `remove_logo=true`. */
export async function updateBranding(form: FormData): Promise<Branding> {
  const { data } = await api.patch<Branding>("/branding/", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
